import React from 'react';
import { navigate, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  fontSize,
  headingStyles,
} from '../styles';
import { Link } from './ui';
import { buildUrl } from '../utils';

const StyledRecipeCard = styled.article`
  position: relative;
  color: ${standardColours.white};
  cursor: pointer;
`;

const StyledImage = styled(GatsbyImage)`
  height: 100%;
`;

const StyledContent = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding: 25px;
  background: linear-gradient(
    to bottom,
    ${standardColours.transparent} 30%,
    ${standardColours.black} 100%
  );

  ${minBreakpointQuery.tiny`
    padding: 30px;
  `}

  ${minBreakpointQuery.large`
    padding: 40px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 50px;
  `}
`;

const StyledOverline = styled.p`
  ${fontSize(14)};
  text-transform: uppercase;
  letter-spacing: 1.75px;
`;

const StyledHeading = styled.h3`
  margin-top: 6px;
  ${headingStyles(true)};
  line-height: 1.15;

  ${minBreakpointQuery.small`
    margin-top: 8px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 10px;
  `}
`;

const RecipeCard = ({ image, heading, page, ...props }) => (
  <StyledRecipeCard
    onClick={() => navigate(buildUrl(page.slug, page))}
    {...props}
  >
    <StyledImage image={image.gatsbyImageData} alt={image.alt} />
    <StyledContent>
      <StyledOverline>Recipe</StyledOverline>
      <StyledHeading>
        <Link to={page}>{heading}</Link>
      </StyledHeading>
    </StyledContent>
  </StyledRecipeCard>
);

export default RecipeCard;

export const RecipeCardFragment = graphql`
  fragment RecipeCardFragment on DatoCmsRecipe {
    id
    title
    featuredImage {
      gatsbyImageData(width: 710, height: 850)
      alt
    }
    ...LinkFragment
  }
`;
